export const colors = {
  gray1: "#333333",
  gray3: "#828282",
};
